export default function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/wordpresssmsv/wp-content/themes/smsv/node_modules/swiper/core/classes/removeClasses.js
// module id = 73
// module chunks = 0